import { yupResolver } from "@hookform/resolvers/yup"
import { useState } from "react"
import * as yup from "yup"

import DialogProvider from "@components/dialog_provider"
import TextInput from "@components/text_input"
import { useCustomerPageContext } from "@contexts/customer"
import useControlledForm from "@hooks/use_controlled_form"
import { Box, Stack } from "@mui/material"
import {
  InvoiceData,
  UpdateInvoiceData
} from "@pages/customer/infos/tabs/invoices"
import { PaymentStatus } from "__generated__/graphql"
import TextActionForm from "@components/text_action_form"

export type PaymentFormData = {
  paymentMethod: string
  // amount: number
}

export default function MarkPaymentAsPaidDialog({
  isOpen,
  setClose,
  onSubmition,
  currentInvoice
}: {
  isOpen: boolean
  setClose: () => void
  onSubmition: (input: UpdateInvoiceData) => Promise<void>
  currentInvoice: InvoiceData | undefined
}) {
  const { translate } = useCustomerPageContext()

  const schema = yup
    .object({
      paymentMethod: yup
        .string()
        .required(translate("payment_method_field_is_required"))
      // amount: yup.number().required(translate("amount_field_is_required"))
    })
    .required()

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid }
  } = useControlledForm<PaymentFormData>({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues: {
      paymentMethod: "BANK_TRANSFER"
    }
  })

  const [loading, setLoading] = useState(false)

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
    reset()
  }

  async function onSubmit(data: PaymentFormData) {
    setLoading(true)
    await onSubmition({
      amountPaid: currentInvoice?.amountPaid,
      // amountPaid: data.amount,
      paymentMethod: data.paymentMethod,
      status: PaymentStatus.Paid
    })
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("mark_payement_as_paid")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("save"),
        color: "primary",
        onClick: handleSubmit(onSubmit),
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <Box sx={{ pt: 2 }}>
          <TextActionForm
            text={currentInvoice?.amountPaid}
            label={translate("amount")}
            backgroundColor="secondary"
          />
        </Box>
        <TextInput<PaymentFormData>
          type="select"
          label={translate("payment_method")}
          disabled={loading}
          name="paymentMethod"
          placeholder={translate("select")}
          control={control}
          selectOptions={[
            { label: "Bank Transfer", value: "BANK_TRANSFER" },
            { label: "Credit Card", value: "CREDIT_CARD" },
            { label: "Cash", value: "CASH" }
          ]}
        />

        {/* <TextInput<PaymentFormData>
          type="number"
          label={translate("amount")}
          disabled={loading}
          name="amount"
          placeholder="0"
          control={control}
        /> */}
      </Stack>
    </DialogProvider>
  )
}
